module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [(_vm.itemDetail.link) ? _c('div', {
    staticClass: "goods",
    on: {
      "click": _vm.buy
    }
  }, [_c('div', {
    staticClass: "goods-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.itemDetail.coverImage.url,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "goods-info"
  }, [_c('p', {
    staticClass: "goods-title"
  }, [_vm._v(_vm._s(_vm._f("replaceStr")(_vm.itemDetail.title)))]), _vm._v(" "), _c('p', {
    staticClass: "goods-subtitle"
  }, [_vm._v(_vm._s(_vm.itemDetail.subTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_vm._v("立即购买")])]) : _vm._e(), _vm._v(" "), (_vm.itemDetail.video) ? _c('div', {
    staticClass: "video"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.itemDetail.video)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.itemDetail.tips) ? _c('div', {
    staticClass: "tips"
  }, [_c('img', {
    attrs: {
      "src": require("./instruct_nor.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("温馨提示：" + _vm._s(_vm.itemDetail.tips))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info-l"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.itemDetail.title))]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v(_vm._s(_vm.itemDetail.subTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "info-r",
    on: {
      "click": _vm.toService
    }
  }, [_c('img', {
    attrs: {
      "src": require("./service_btn.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("适用车型")]), _vm._v(" "), _c('div', {
    staticClass: "applied",
    domProps: {
      "innerHTML": _vm._s(_vm.itemDetail.applied)
    }
  })]), _vm._v(" "), (_vm.itemDetail.steps) ? _c('div', {
    staticClass: "section",
    staticStyle: {
      "margin-top": "0.8rem"
    }
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("图文教程")]), _vm._v(" "), _c('div', {
    staticClass: "steps",
    domProps: {
      "innerHTML": _vm._s(_vm.itemDetail.steps)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "side-nav"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("./copylink.png"),
      "alt": ""
    },
    on: {
      "click": _vm.copylink
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("./gohome.png"),
      "alt": ""
    },
    on: {
      "click": _vm.gohome
    }
  })])]), _vm._v(" "), (_vm.isShowserviceCode) ? _c('div', {
    staticClass: "showCode",
    on: {
      "click": function () { return _vm.isShowserviceCode = false; }
    }
  }, [_c('img', {
    attrs: {
      "src": "https://static0.xiaote.com/frontend/instructionSheetCode.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10f6362e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/directions/App.vue
// module id = 166
// module chunks = 1